<div class="p-grid rootBody">
  <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 header">
    <div class="p-grid alignHead">
      <a target="_blank" href="{{LOGO_REDIRECT}}" class="p-col-3"><img class="logoImage" src="./assets/img/logo.png"
          alt="Fedex Home" /></a>
      <div class="p-col-9"></div>
    </div>
  </div>
  <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 pd0">
    <router-outlet></router-outlet>
  </div>
  <div class="p-col-12 p-lg-12 p-md-12 p-sm-12 footer">
    <div class="p-grid gridMargin">
      <div class="footAlignLeft p-xl-6 p-lg-6 p-md-6 p-sm-12">
        &copy; Fedex 1995 - {{currentYear}}
      </div>
      <div class="footAlignRight p-xl-6 p-lg-6 p-md-6 p-sm-12">
        <a href="{{PRIVACY_POLICY_URL}}" class="privacyLinkStyle" target="_blank">{{ 'PR_POLICY' | translate }}</a>
      </div>
    </div>
  </div>
</div>